/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ResourceFilter {
    None = 'None',
    AccessRequest = 'AccessRequest',
    Role = 'Role',
    Permission = 'Permission',
    InternalUser = 'InternalUser',
    ExternalUser = 'ExternalUser',
    Application = 'Application',
    InternalUserAccessAssignment = 'InternalUserAccessAssignment',
    ExternalUserAccessAssignment = 'ExternalUserAccessAssignment',
    OrganizationGroup = 'OrganizationGroup'
}


export function instanceOfResourceFilter(value: any): boolean {
    for (const key in ResourceFilter) {
        if (Object.prototype.hasOwnProperty.call(ResourceFilter, key)) {
            if (ResourceFilter[key as keyof typeof ResourceFilter] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ResourceFilterFromJSON(json: any): ResourceFilter {
    return ResourceFilterFromJSONTyped(json, false);
}

export function ResourceFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResourceFilter {
    return json as ResourceFilter;
}

export function ResourceFilterToJSON(value?: ResourceFilter | null): any {
    return value as any;
}

export function ResourceFilterToJSONTyped(value: any, ignoreDiscriminator: boolean): ResourceFilter {
    return value as ResourceFilter;
}

